module.exports = __webpack_public_path__ + "static/ipad_mockup-bed493bc7d74ae6c7363d30b1b5032a1.png";